"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import React, { useEffect, useState } from "react"
import Link from "next/link"
import { Menu, MenuItem, IconButton, useMediaQuery, useTheme } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import styles from "../TherapistsPage.module.css"
import ZestLifeName from "../../../components/common/icons/ZestLifeName"

export default function TherapistsNavbar() {
  const [anchorEl, setAnchorEl] = useState(null)
  const theme = useTheme()
  const isMobile = useMediaQuery("(max-width:600px)")
  const open = Boolean(anchorEl)

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = (href) => {
    if (href.startsWith("#")) {
      const target = document.querySelector(href)
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    }
    handleMenuClose()
  }

  useEffect(() => {
    // Navigation bar scroll behavior
    const navbar = document.getElementById("navbar")
    let lastScrollTop = 0

    const handleScroll = () => {
      const scrollTop = window.scrollY
      // Show navbar after scrolling past hero section (roughly 80vh)
      if (scrollTop > window.innerHeight * 0.8) {
        navbar.classList.add(styles.visible)
      } else {
        navbar.classList.remove(styles.visible)
      }
      lastScrollTop = scrollTop
    }

    // Initial check for scroll position
    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })

    // Smooth scrolling for anchor links
    const handleAnchorClick = (e) => {
      e.preventDefault()
      const target = document.querySelector(e.currentTarget.getAttribute("href"))
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    }
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", handleAnchorClick)
    })

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll)
      document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.removeEventListener("click", handleAnchorClick)
      })
    }
  }, [])

  return (
    <nav className={styles.navbar} id="navbar">
      <div className={styles.navContainer}>
        <Link href="/" className={styles.navLink}>
          <ZestLifeName />
        </Link>
        <div className={styles.navMenu}>
          {!isMobile ? (
            <>
              <a href="#referrals" className={styles.navLink}>
                For Therapists
              </a>
              <Link href="/pricing" className={styles.navLink}>
                Pricing
              </Link>
              <Link href="/signup" className={` ${styles.navSignup}`}>
                Sign Up
              </Link>
            </>
          ) : (
            <>
              <Link href="/signup" className={`${styles.navSignup}`}>
                Sign Up
              </Link>
              <IconButton
                className={styles.menuButton}
                onClick={handleMenuClick}
                aria-label="menu"
                aria-controls={open ? "navigation-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MenuIcon className={styles.menuIcon} />
              </IconButton>
              <Menu
                id="navigation-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                slotProps={{
                  list: {
                    "aria-labelledby": "menu-button",
                  },
                  paper: {
                    className: styles.menuPaper,
                  },
                }}
              >
                <MenuItem
                  onClick={() => handleMenuItemClick("#referrals")}
                  className={styles.menuItem}
                >
                  For Therapists
                </MenuItem>
                <MenuItem
                  component={Link}
                  href="/pricing"
                  onClick={handleMenuClose}
                  className={styles.menuItemLink}
                >
                  Pricing
                </MenuItem>
              </Menu>
            </>
          )}
        </div>
      </div>
    </nav>
  )
}
